<script lang="ts">
  import { Milliseconds, Seconds } from '@yp/common/units.ts';
  import { onMount } from 'svelte';
  import { fade, slide } from 'svelte/transition';
  import { setCallback, type Toast, toastStyle } from '../context.ts';
  import { Icon } from './index.ts';

  const toasts = $state<Toast[]>([]);

  const defaultDuration = Seconds(3);
  let timerId = $state<number>();

  // TODO: Maybe switch to an async "pump" method.
  function pop() {
    toasts.shift();
    if (toasts.length > 0) {
      timerId = setTimeout(
        () => pop(),
        (toasts[0].duration ?? defaultDuration).value(Milliseconds),
      ) as unknown as number;
    }
  }

  function dismiss() {
    if (toasts.length > 0) {
      clearTimeout(timerId);
      pop();
    }
  }

  const cb = setCallback('toast');

  onMount(async () => {
    cb((t: Toast) => {
      toasts.push({ ...t });
      if (toasts.length === 1) {
        timerId = setTimeout(
          () => pop(),
          (toasts[0].duration ?? defaultDuration).value(Milliseconds),
        ) as unknown as number;
      }
    });
  });
</script>

<div
  aria-live="assertive"
  class="z-[100] pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6">
  <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
    <!--
      Notification panel, dynamically insert this into the live region when it needs to be displayed

      Entering: "transform ease-out duration-300 transition"
        From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        To: "translate-y-0 opacity-100 sm:translate-x-0"
      Leaving: "transition ease-in duration-100"
        From: "opacity-100"
        To: "opacity-0"
    -->
    {#if toasts.length}
      {@const t = toasts[0]}
      {@const ts = toastStyle(t)}
      <!-- <Transition
        show={true}
        enter="transform ease-out duration-300 transition"
        enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enterTo="translate-y-0 opacity-100 sm:translate-x-0"
        leave="transition ease-in duration-100"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"> -->
      <div
        class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg shadow-lg ring-1 ring-black/5"
        style:color="var({ts.fg})"
        style:background="var({ts.bg})"
        in:slide
        out:fade>
        <div class="p-4">
          <div class="flex items-start">
            {#if ts.icon}
              <Icon icon={ts.icon} />
            {/if}
            <div class="ml-3 w-0 flex-1 pt-0.5">
              <p class="text-base font-medium">{t.title}</p>
              {#if t.text}
                <p class="mt-1 text-sm">{t.text}</p>
              {/if}
            </div>
            <div class="ml-4 flex shrink-0">
              <button
                type="button"
                class="inline-flex rounded-md hover:text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                onclick={() => dismiss()}>
                <span class="sr-only">Close</span>
                <Icon icon="close" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- </Transition> -->
    {/if}
  </div>
</div>
